<template>
<div class="transfers-detail" v-if="flag==index&&detailShow" :style="{height:transferDetail.stateSet&&transferDetail.stateSet.length?transferDetail.stateSet.length*25+detailHeight+'px':detailHeight+'px'}">
    <div class="transfers-detail-title">
        <span v-if="item.tranferWay=='restore'"> {{$t('language.cloudBackup.restoreDetails')}} </span>
        <span v-else> {{$t('language.cloudBackup.backupDetails')}} </span>
        </div>
    <div class="detail-count" v-if="transferDetail.runningStatus==1">
         <div class="transfer-line" >{{$t('language.common.countFiles')}}:({{transferDetail.readyFindFileCount}}{{$t('language.common.transferFiles')}},{{transferDetail.totalBytes|formatByte}})</div>
    </div>
    <div class="detail-one">
         <!-- 显示源 -->
         <span  v-if="(item.tranferWay=='restore'||item.tranferWay=='retry-restore')&&(item.status=='Running'||item.status=='Waiting')">
             <div class="transfer-line"   @click.stop="toRestoreSource(item)"><span style="float:left;">{{$t('language.common.from')}}:</span>
                  
                  <div class="catelog-color catelog-style"  :title="item.fromItem.nodes|getCatalog">{{item.fromItem.nodes|getCatalog}}</div>
             </div>

         </span>
         <span v-else>
             <div class="transfer-line" v-if="!transferDetail.sourceNode.data"  @click.stop="toSourceCatalog(transferDetail)"><span style="float:left;">{{$t('language.common.from')}}:</span>
                  <div class="catelog-color catelog-style"  :title="transferDetail.sourceNode|getCatalog|getCatalogTitle">{{transferDetail.sourceNode|getCatalog}}</div>
             </div>
             <div class="transfer-line"  v-if="transferDetail.sourceNode.data && transferDetail.sourceNode.data.length"  @click.stop="openBackupSource(transferDetail.sourceNode)"><span style="float:left;">{{$t('language.common.from')}}:</span>
                 <div class="catelog-color catelog-style"  :title="transferDetail.sourceNode.data[0].nodes|getCatalog|getBackupInfo">{{transferDetail.sourceNode.data[0].nodes|getCatalog|getBackupInfo}}</div>
            </div>
         </span>
         <!-- 显示目标目录 -->
        <span  v-if="(item.tranferWay=='restore'||item.tranferWay=='retry-restore')&&(item.status=='Running'||item.status=='Waiting')">
              <span v-if="item.toItem">
                  <div v-if="item.toItem.data&&item.toItem.data.length">
                    <div class="transfer-line" @click.stop="openBackupToItems(item.toItem)"><span style="float:left;">{{$t('language.common.to')}}:</span>
                    <div class="catelog-color catelog-style" :title="item.toItem.data[0].nodes|getCatalog|getBackupInfo">{{item.toItem.data[0].nodes|getCatalog|getBackupInfo}}</div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="transfer-line" @click.stop="toRestoreAimCatalog(item.toItem)"><span style="float:left;">{{$t('language.common.to')}}:</span>
                    <div class="catelog-color catelog-style" :title="item.toItem.nodes|getCatalog">{{item.toItem.nodes|getCatalog}}</div>
                    </div>
                  </div>
              </span>
              <span v-else>
                     <div class="transfer-line" @click.stop="toRestoreOriginalAimCatalog(item)"><span style="float:left;">{{$t('language.common.to')}}:</span>
                   <div class="catelog-color catelog-style" title="Original">Original</div>
                   </div>
              </span>

        </span>
        <span v-else>
           <div class="transfer-line" v-if="!transferDetail.desNode.data" @click.stop="toAimCatalog(transferDetail)"><span style="float:left;">{{$t('language.common.to')}}:</span>
               <div class="catelog-color catelog-style" :title="transferDetail.desNode|getCatalog|getCatalogTitle">{{transferDetail.desNode|getCatalog}}</div>
           </div>
            <div class="transfer-line" v-if="transferDetail.desNode.data  && transferDetail.desNode.data.length"  @click.stop="openBackupSource(transferDetail.desNode)" :title='transferDetail.desNode.data[0].nodes|getCatalog|getBackupInfo'>
                    <span style="float:left;">{{$t('language.common.to')}}:</span>

                    <div class="catelog-color catelog-style" :title="transferDetail.desNode.data[0].nodes|getCatalog|getBackupInfo"> {{transferDetail.desNode.data[0].nodes|getCatalog|getBackupInfo}} </div>
            </div>
        </span>
        
    </div>
    <div class="detail-two">
        <div class="transfer-line">{{$t('language.common.fileProcess')}}:
            <span v-if="transferDetail.runningStatus!=0">{{transferDetail.readyTranFileCount}}<span v-if="transferDetail.readyTranFileCount!=null&&transferDetail.readyFindFileCount!=null">/</span>{{transferDetail.readyFindFileCount}}</span>
            </div>
        <div class="transfer-line">
            <span class="transfer-column-left">{{$t('language.common.dataProcess')}}:
                <span v-if="transferDetail.runningStatus!=0"> {{transferDetail.totalReadedBytes|formatByte}}<span v-if="transferDetail.totalReadedBytes!=null&&transferDetail.totalBytes!=null">/</span>{{transferDetail.totalBytes|formatByte}}</span>
                </span>
           
            <span class="transfer-column-right">{{$t('language.popup.progress')}}:<span v-if="transferDetail.runningStatus>1">{{percent+'%'}}</span></span>
        </div>
        <div class="transfer-line">
            <span class="transfer-column-left">{{$t('language.common.startTime')}}:
                <span v-if="transferDetail.runningStatus!=0">{{transferDetail.taskStartTimeLong|transferTime}}</span></span>
            <span class="transfer-column-right">{{$t('language.common.currentRate')}}: <span v-if="transferDetail.runningStatus>1">{{speed}}</span></span>
        </div>
    </div>
    <div class="detail-three" v-if="transferDetail&&transferDetail.stateSet" :style="{height:transferDetail.stateSet&&transferDetail.stateSet.length?transferDetail.stateSet.length*25+20+'px':'0px'}">
        <div class="transfer-line" style="float:left" :key="index" v-for="(sitem ,index) in transferDetail.stateSet">
            <span v-if="item.tranferWay=='restore'&&sitem.sourcePath" class="transfer-column-left transfering-file-line" :title="sitem.sourcePath">
                {{sitem.sourcePath}}
            </span>
            <span v-else class="transfer-column-left transfering-file-line" :title="getTitle(sitem)">
                {{sitem.pnodes|getCatalog}}\{{sitem.itemName}}
            </span>
            <span v-if="!isVip()">
                <span class="transfer-column-right transfering-file-line upgradeMulti" v-if='sitem.status!=0'  @click.stop="switchToPay()">{{$t('language.common.upgradeMulti')}}</span>
                <span class="transfer-column-right transfering-file-line" v-if="sitem.status==0">{{getItemRate(sitem)}}%</span>
            </span>
            <span v-else>
                <span class="transfer-column-right transfering-file-line"  v-if="getItemRate(sitem)&&sitem.status==0">{{getItemRate(sitem)}}%</span>
                <span class="transfer-column-right transfering-file-line"  v-else >0%</span>    
            </span>
        </div>
    </div>
    <div class="detail-four">
        <div class="transfer-line">
            <div class="icon-util shop-cart shop-cart-position"></div>
            <div v-if="item.tranferWay=='restore'">
             <span class="transfer-line-des" v-if="isVip()">{{$t('language.cloudBackup.thankRestore')}}</span>
            <span class="transfer-line-des" v-if="!isVip()">{{$t('language.cloudBackup.restoreSimult')}} </span>
            </div>
            <div v-else>
                 <span class="transfer-line-des" v-if="isVip()">{{$t('language.cloudBackup.thankSubscrib')}}</span>
                 <span class="transfer-line-des" v-if="!isVip()">{{$t('language.cloudBackup.maximunBack')}} </span>
            </div>
        </div>
    </div>
    <div>
        <div class="transfer-line" v-if="!isVip()">
            <button class="upgrade-now" @click.stop="switchToPay()">{{$t('language.common.upgradeNow')}}</button>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import googleAnalyticsUtil from "../../../../js/workspace/google_analytics_util.js";
export default {
    props: ['flag', 'index', 'transferDetail', 'speed', 'detailShow', 'percent', 'transferDetailChange','item'],
    data: function () {
        return {
            itemDetail: this.transferDetail,
            detailHeight: 248,
            user:commonUtils.getUser(),
        }
    },
    watch: {
        transferDetailChange(newValue, oldValue) {
            this.$forceUpdate();
        },
          '$store.state.transferDetailChange': function (newValue, oldValue) {
            this.$forceUpdate();
            this.$parent.$forceUpdate();
            this.$parent.showTaskStatus();
        }
    },
    created() {
        if (this.transferDetail) {
            this.itemDetail = this.transferDetail;
        }
    },
    mounted() {

    },
    methods: {
        toSourceCatalog(item) {
                let fromItem = {
                    driveId: item.sourceToken,
                    nodes: item.sourceNode,
                    driveType: item.sourceCloudType,
                    name: item.sourceFilename,
                    id: item.sourceId
                };
                fromItem.id=fromItem.nodes[0].fileId;
                this.$parent.toSourceCatalog(fromItem);
        },
        toAimCatalog(item) {
            let toItem = {
                driveId: item.desToken,
                nodes: item.desNode,
                driveType: item.desCloudType,
                name: item.desNode[0].filename,
                id: item.desNode[0].fileId
            };
            this.$parent.toAimCatalog(toItem);
        },
        switchToPay() {
            googleAnalyticsUtil.pay1(this,"threads");
            commonUtils.switchToPay();
        },
        isVip() {
            let flag = commonUtils.isVip();
            let boxHeight = 390;
            if (flag) {
                boxHeight = 350;
            } else {
                boxHeight = 390;
            }
            if(this.transferDetail&&!this.transferDetail.stateSet){
                 this.transferDetail.stateSet=[];
            }
            if(this.$parent.$refs.threadParents){
                this.$parent.$refs.threadParents.style.height = (this.transferDetail.stateSet.length) * 25 + boxHeight + 'px';
            }
            
            let dom = this.$parent.$refs.threadParents.parentElement;
            let pDom = this.$parent.$refs.threadParents.parentElement.parentElement;
            dom.style.height = (this.transferDetail.stateSet.length) * 25 + boxHeight + 'px';
            pDom.style.height = (this.transferDetail.stateSet.length) * 25 + boxHeight + 'px';
            return flag;
        },
        getItemRate(item){
           if(!item.totalBytes){
               return 0;
           }
           let rate=((item.readedBytes/item.totalBytes)*100).toFixed(0);
           return rate;
        },
        getTitle(item){
           var title;
           title=commonUtils.getCatalog(item.pnodes);
           title = title +'\\'+item.itemName;
           return title;
        },
        openBackupSource(value){
            this.$parent.openBackupSource(value);
        },
        openBackupToItems(value){
            this.$parent.openBackupToItems(value);
        },
        toRestoreSource(item){
            this.$parent.toRestoreSource(item);
        },
        toRestoreAimCatalog(item){
             this.$parent.toAimCatalog(item);
        },
        toRestoreOriginalAimCatalog(item){
              this.$parent.toOriginal(item);
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return '';
            if (value.length > 39) {
                return value.slice(0, 39) + '...';
            }
            return value;
        },
    }
}
</script>

<style scoped>
.transfers-detail {
    width: 100%;
    height: 100%;
    min-height: 248px;
    /*no*/
    font-size: 12px;
    /*no*/
    line-height: 20px;
    /*no*/
    color: #6f7886;
    box-sizing: border-box;
    padding: 10px 20px 16px 20px;
    /*no*/
}

.transfers-detail-title {
    font-size: 16px;
    /*no*/
    font-weight: bold;
    color: #000;

}

.detail-one {
    width: 100%;
    height: 35px;
    /*no*/
    margin: 10px 0px 16px 0px;
    /*no*/
}


.detail-two {
    width: 100%;
    height: 50px;
    /*no*/
    margin-bottom: 16px;
    /*no*/
}

.detail-three {
    width: 100%;
    height: 35px;
    /*no*/
    margin-bottom: 16px;
    /*no*/
}

.detail-four {
    width: 100%;
    height: 35px;
    /*no*/
}

.transfer-line {
    width: 100%;
}

.transfer-column-left {
    width: 38%;
    float: left;
    margin-right: 3%;

}

.transfering-file-line {
    height: 25px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.transfer-column-right {
    width: 56%;
    float: left;

}

.transfer-line-des {
    line-height: 40px;
    /*no*/
}

.catelog-style {
    max-width: 1000Px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tabs_backup_detail.vue